var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 44"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#check-outline_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19 26.17 14.83 22l-1.42 1.41L19 29l12-12-1.41-1.41z"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 43,
  height: 43,
  x: 0.5,
  y: 0.5,
  stroke: "currentColor",
  rx: 21.5
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "check-outline_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 10,
  y: 10,
  fill: "#fff",
  rx: 12
})))));
export default SvgCheckOutline;